import { h } from "preact";

import classname from "../../../../foundation/utils/classname";

import styles from "./LoadingDots.module.css";

interface LoadingDotsProps {
    class?: string;
}

function LoadingDots({
    class: cssClass
}: LoadingDotsProps) {
    return (
        <div class={classname(styles.loadingDots, cssClass)}>
            <div class={classname(styles.loadingDot, styles.yellow)}/>
            <div class={classname(styles.loadingDot, styles.lightOrange)}/>
            <div class={classname(styles.loadingDot, styles.orange)}/>
            <div class={classname(styles.loadingDot, styles.peach)}/>
        </div>
    );
}

export default LoadingDots;
